export const SESSION_SLICE_KEY = 'session' as const;
